module.exports = __webpack_public_path__ + "img/375_news_sub_img2.cef6f4bf.png";